<div class="teams-wrap d-flex flex-wrap">
  <div class="team-block {{'team_' + (i + 1)}} d-flex align-items-center mb-1 mr-1"  *ngFor="let team of gameModeInfo.teams; let i = index;">
    <!-- TODO - continue-->
    <span class="team-name-text text-truncate"
          title="{{gameModeInfo.teams[i].name}}"
          (click)="changeTeamName(i)"
          [ngStyle]="{'cursor': localUser.accessType === AccessType.TEACHER ? 'pointer':'default'}">
        {{gameModeInfo.teams[i].name}}</span>
    <span class="score-value mx-auto">{{gameModeInfo.scoreByTeamId[team.id]}}</span>
    <span id="{{'team_talk_join_' + (i + 1)}}"
          class="team-talk-join fas fa-phone-alt d-flex align-items-center justify-content-center ml-1"
          *ngIf="gameModeInfo.isTeamTalkOn && localUser.accessType === AccessType.TEACHER"
          (click)="changeTeacherTeam(team.id)"
          [ngClass]="{'on' : gameModeInfo.teacherOnTeamIndex !==null  && gameModeInfo.teacherOnTeamIndex === i}"
          title="{{(gameModeInfo.teacherOnTeamIndex === i ? 'Leave ': 'Join ') + team.name}}"></span>
  </div>
</div>
